import { Button, type ButtonProps } from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";

type EditButtonProps = Omit<ButtonProps, "icon">;

export const EditButton = (props: EditButtonProps) => (
  <Button leftIcon={<Icon name="pencil-01" />} variant="ghost" {...props} />
);
